// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '../../common/css/quill.size.css'
import '../../common/css/quill.font.css'
import '../../common/css/quill.lineheight.css'

import Vue from 'vue'
import VueQuillEditor from 'vue-quill-editor'
import imageResize from 'quill-image-resize-module' // 图片缩放组件引用
import { ImageExtend } from 'quill-image-extend-module'
// import Quill from 'quill'

VueQuillEditor.Quill.register('modules/ImageExtend', ImageExtend) // 注册
// 注册缩放插件
VueQuillEditor.Quill.register('modules/imageResize', imageResize)
// 配置quill字号
let Size = VueQuillEditor.Quill.import('attributors/style/size')
Size.whitelist = ['14px', '16px', '18px', '20px', '30px', '32px']
VueQuillEditor.Quill.register(Size, true)
// 配置quill字体
let fonts = ['Microsoft-YaHei', 'SimSun', 'SimHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif']
VueQuillEditor.Quill.imports['formats/font'].whitelist = fonts
VueQuillEditor.Quill.register(VueQuillEditor.Quill.imports['formats/font'])
// 配置行高
// const Parchment = Quill.import('parchment')
// class LineHeightAttributor extends Parchment.Attributor.Style { }
// const LineHeightStyle = new LineHeightAttributor('lineHeight', 'line-height', {
//   scope: Parchment.Scope.INLINE, whitelist: ['1', '1.5', '2']
// })
// VueQuillEditor.Quill.register({'formats/lineHeight': LineHeightStyle}, true)

Vue.use(VueQuillEditor)



// WEBPACK FOOTER //
// ./src/utils/quill/quill.configure.js